import {AfterViewInit, Component, inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import { GestionarActividadesPendientesComponent } from './gestionar-actividades-pendientes/gestionar-actividades-pendientes.component';
import { TabViewModule } from 'primeng/tabview';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-gestion-tramite',
  standalone: true,
  imports: [
    TabViewModule, TranslateModule, CustomTitle,
    GestionarActividadesPendientesComponent
  ],
  templateUrl: './gestion-tramite.component.html',
  styleUrl: './gestion-tramite.component.scss'
})
export class GestionTramiteComponent implements OnInit, AfterViewInit{
  activeTabIndex: number = 0;

   @ViewChildren(GestionarActividadesPendientesComponent) pendientes !: QueryList<GestionarActividadesPendientesComponent>;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor() { }

  ngOnInit(): void {
    this.titleService.changeTitle('msg.gestionTramites');
  }
  ngAfterViewInit(): void {
    this.pendientes.get(0)?.getMisTramitesByDependencia();
  }

  activeIndexChange(index: number) {
    if (this.pendientes && this.pendientes.length > index) {
      this.pendientes.get(index)?.getMisTramitesByDependencia();
    }
  }
}
